import styled from '@emotion/styled';
import { forPhoneOnly, forTabletLandscapeDown, Variables } from '../base';

export const sidePanelWidth = '550px';

interface ISidePanelStyleProps {
    width?: number;
}

interface IResizeHandleProps {
    isResizing?: boolean;
}

export const SidePanel = styled.div<ISidePanelStyleProps>`
    display: flex;
    flex-direction: column;

    position: absolute;
    top: 0;
    left: ${props => props.width ? `calc(100% - ${props.width}px)` : `calc(100% - ${sidePanelWidth})`};
    right: 0;
    max-width: ${props => props.width ? `${props.width}px` : sidePanelWidth};
    width: ${props => props.width ? `${props.width}px` : sidePanelWidth};
    height: 100%;
    z-index: 10000;

    border: 0;
    background-color: ${Variables.Colors.white};
    box-shadow: ${Variables.Shadows.small}, ${Variables.Shadows.border};
    overflow: hidden;

    &.fixed {
        position: fixed;
    }

    ${forTabletLandscapeDown(`
        top: ${Variables.topnavSize};
        height: calc(100% - ${Variables.topnavSize});
        width: 100%;
    `)};

    ${forPhoneOnly(`
        position: fixed;
        left: 0;
        max-width: unset;
    `)}
`;

export const ResizeHandle = styled.div<IResizeHandleProps>`
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    cursor: ew-resize;
    background-color: transparent;
    z-index: 10001;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${Variables.Colors.b100};
    }

    ${props => props.isResizing && `
        background-color: ${Variables.Colors.b100};
    `}

    /* Hide on mobile */
    ${forTabletLandscapeDown(`
        display: none;
    `)};
`;
